import { all, call, put, select, take, takeLatest } from 'redux-saga/effects';

import { FETCH_USERS_FAILURE, FETCH_USERS_SUCCESS, SELECT_DEALER } from 'constants/ActionTypes';
import { PATH } from 'constants/RoutesConstants';
import { scopeToPage } from 'modules/app/sagas/utils';
import * as deviceActions from 'modules/devices/actions/core';
import * as types from 'modules/devices/actionTypes';
import {
  getRequestParameters,
  getOSVersionRequestParameters,
  getAppVersionRequestParameters,
} from 'modules/devices/selectors/dashboard';
import { SELECT_GROUP } from 'modules/groups/actionTypes';
import { getUsers } from 'modules/users/actions';

export function* refreshApp(fetchFilterValues: unknown = false) {
  const params: ReturnType<typeof getRequestParameters> = yield select(getRequestParameters);

  if (typeof fetchFilterValues === 'boolean' && fetchFilterValues && params.userId?.length > 0) {
    yield put(getUsers({ ids: params.userId }));
    yield take([FETCH_USERS_SUCCESS, FETCH_USERS_FAILURE]);
  }

  yield put(deviceActions.fetchDevices({ ...params, page: 0 }, { source: 'dashboard' }));
}

function* refreshFiltersData() {
  const osParams: ReturnType<typeof getOSVersionRequestParameters> = yield select(getOSVersionRequestParameters);
  const appVersionParams: ReturnType<typeof getAppVersionRequestParameters> = yield select(getAppVersionRequestParameters);

  yield all([
    put(deviceActions.fetchDevicesOSVersion(osParams)),
    put(deviceActions.fetchDevicesAppVersion(appVersionParams)),
  ]);
}

const shouldRefreshDashboard = ({ type }: { type: string | number | symbol }) =>
  [
    SELECT_DEALER,
    SELECT_GROUP,
    types.SET_FILTER,
    types.CLEAR_FILTER,
    types.REMOVE_FILTER,
    types.CREATE_DEVICE_SUCCESS,
    types.DELETE_DEVICE_SUCCESS,
  ].includes(type as string);

function* onPageWorker() {
  yield call(refreshApp);
  yield call(refreshFiltersData);

  yield takeLatest(shouldRefreshDashboard, refreshApp);
  yield takeLatest([SELECT_DEALER, SELECT_GROUP], refreshFiltersData);
}

export default function* dashboardSaga() {
  yield scopeToPage([PATH.DEVICES, PATH.GROUP_DEVICES], onPageWorker);
}
